import { NotificationsPage } from './NotificationsPage'

export function NotificationsPageWrapper() {
  return <NotificationsPage />
}
